import React, { useEffect, useState, useContext,useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Tooltip,
  Chip,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import itLocale from '@fullcalendar/core/locales/it'; // locale italiano v5.8
import scadenzaApi from '../../api/scadenzaApi';
import contribuenteApi from '../../api/contribuenteApi';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';
import PaymentIcon from '@mui/icons-material/Payment';
import EventIcon from '@mui/icons-material/Event';
import { scadenzaStatusMap } from '../../utils/scadenzaStatusMapper';
import '../../styles/calendar.css';
import QRCode from 'react-qr-code';
import { QrCode2 } from '@mui/icons-material';

export default function ScadenzeCalendarPageDesktop() {
  const { user, token } = useContext(AuthContext);

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtroStato, setFiltroStato] = useState('da_pagare');
  const [filtroContribuente, setFiltroContribuente] = useState(
      user.role === 'CONTRIBUENTE' ? user.contribuenteId : null
  );
  const [contribuenti, setContribuenti] = useState([]);
  const [scadenzeMese, setScadenzeMese] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedScad, setSelectedScad] = useState(null);
  const today = new Date();
  const [calendarMonth, setCalendarMonth] = useState(today.getMonth()); // 0-11
  const [calendarYear, setCalendarYear] = useState(today.getFullYear());
  console.log("id contribuente",filtroContribuente);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const scadenzaHighlight = query.get("scadenza");
  const calendarRef = useRef(null); // 🔹 ref per FullCalendar
  // mappa colori per stati
  const statoColors = {
    da_pagare: 'red',
    pagata: 'green',
    scaduta: 'yellow'
  };
  useEffect(() => {
    fetchContribuenti();
  }, []);

  useEffect(() => {
    fetchScadenze();
  }, [filtroStato, filtroContribuente]);

  const fetchContribuenti = async () => {
    if (user.role === "STUDIO") {
      try {
        const params = { page: 0, size: 100000, sort: "cognome,ASC" };
        const r = await contribuenteApi.listbystudio(user.studioId, params);
        setContribuenti(r.data.content || []);
        console.log("contribuenti",r.data.content);
      } catch (err) {
        console.error(err);
      }
    }
  };

const fetchScadenze = async (month = calendarMonth, year = calendarYear) => {
  if (user.role === "STUDIO" && !filtroContribuente) return;
  if (!token) return;

  try {
    setLoading(true);

    let res;
    if (filtroStato === "tutte") {
      res = await scadenzaApi.listbycontribuenteandstato(filtroContribuente, { stato: '' });
    } else {
      res = await scadenzaApi.listbycontribuenteandstato(filtroContribuente, { stato: filtroStato });
    }

    const data = res.data || [];
    setScadenzeMese(data.length);

    // mappa eventi per FullCalendar
    const fcEvents = data.map(s => ({
      id: s.id.toString(),
      title: s.tipo,
      start: s.dataScadenza,
      backgroundColor: s.id.toString() === scadenzaHighlight ? '#ff9800' : statoColors[s.stato] || '#1976d2',
      borderColor: s.id.toString() === scadenzaHighlight ? '#000000' : statoColors[s.stato] || '#1976d2',
      extendedProps: { ...s }
    }));

    setEvents(fcEvents);

    // evidenzia evento e forza vista settimana
if (scadenzaHighlight) {
  const api = calendarRef.current.getApi();
  const target = data.find(s => s.id.toString() === scadenzaHighlight);
  if (target) {
    requestAnimationFrame(() => {
      api.changeView('timeGridWeek', target.dataScadenza); // vista settimana + scroll
      // blink
      const el = document.querySelector(`[data-event-id="${target.id}"]`);
      if (el) {
        el.classList.add('blink-event');
        setTimeout(() => el.classList.remove('blink-event'), 2000);
      }
    });
  }
}


  } catch (err) {
    console.error(err);
    setError("Errore caricamento scadenze");
  } finally {
    setLoading(false);
  }
};

  const handleStatoChange = e => setFiltroStato(e.target.value);
  const handleContribuenteChange = e => setFiltroContribuente(e.target.value);
  const markPaid = async (id) => {
    try {
      await scadenzaApi.setpagatamanuale(id);
      fetchScadenze();
    } catch (err) {
      console.error("Errore pagamento", err);
    }
  };

  const onEventClick = (info) => {
    const s = info.event.extendedProps;
    setSelectedScad(s);
    setModalOpen(true);
  };
const handleDatesSet = (arg) => {
  //const viewStart = arg.start; // primo giorno della vista
  //setCalenMonth(viewStart.getMonth());
  //setCalenYear(viewStart.getFullYear());
};



const renderEventContent = (eventInfo) => {
  const s = eventInfo.event.extendedProps;
  const cfg = scadenzaStatusMap[s.direzione!="ENTRATA"?s.stato:s.stato!="pagata"?"da_incassare":s.stato]; // usa la stessa mappa che hai nel documento
  const isToday = new Date(s.dataScadenza).toDateString() === new Date().toDateString();

  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="body2"><b>{s.tipo}</b></Typography>
          <Typography variant="caption">Rata: {s.numerorata}</Typography><br />
          <Typography variant="caption">Importo: {s.importo}€</Typography><br />
          <Typography variant="caption">Data: {formatDate(s.dataScadenza)}</Typography><br />
          <Typography variant="caption">Codice: {s.codiceModuloPagamento || '-'}</Typography>
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 11,
          whiteSpace: 'normal',
          lineHeight: 1.1,
          p: 0.5,
          border: isToday ? '1px solid black' : 'none',
          gap: 0.5,
          color: '#000000',
          backgroundColor:'#ffffff'
        }}
      >


        <Box>
          <Typography variant="caption" sx={{ fontWeight: 600 }}> {s.tipo}</Typography>
          <Typography variant="caption"> {s.importo}€ </Typography>
          <Typography variant="caption">
                  {/* Chip per stato come nel dettaglio documento */}
                  <Chip
                    label={cfg?.label || s.stato}
                    size="small"
                    color={cfg?.color || 'default'}
                    sx={{ fontSize: 10 }}
                  />
                  </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};


  return (
    <Container sx={{ mt: 4 }}>
      {error && <Alert severity="error">{error}</Alert>}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={48}/>
        </Box>
      )}

      <Typography variant="h4" sx={{ mb: 2 }}>Calendario Scadenze</Typography>
<Typography variant="h4" sx={{ mb: 2 }}><Chip icon={<EventIcon />} label={`Totale scadenze: ${scadenzeMese}`} color="primary" /></Typography>

      <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Stato</InputLabel>
          <Select value={filtroStato} label="Stato" onChange={handleStatoChange}>
            <MenuItem value="da_pagare">Da pagare</MenuItem>
            <MenuItem value="da_incassare">Da incassare</MenuItem>
            <MenuItem value="pagata">Pagata/Incassata</MenuItem>
            <MenuItem value="scaduta">Scaduta</MenuItem>
            <MenuItem value="tutte">Tutte</MenuItem>
          </Select>
        </FormControl>
        {contribuenti.length > 0 && (
          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel>Contribuente</InputLabel>
            <Select value={filtroContribuente} label="Contribuente" onChange={handleContribuenteChange}>
              {contribuenti.map(c => (
                <MenuItem key={c.id} value={c.id}>{c.nome} {c.cognome}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Stack>

      <Card>
        <CardContent>
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView={scadenzaHighlight?"dayGridWeek":"dayGridMonth"}
              events={events}
              eventContent={renderEventContent}
              eventClick={onEventClick}
              locale={itLocale}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,dayGridWeek'
              }}
              height="auto"
              showNonCurrentDates={false}
            />

        </CardContent>
      </Card>

      {/* MODALE DETTAGLIO SCADENZA */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Dettaglio Scadenza</DialogTitle>
        {selectedScad && (
          <DialogContent>
            <Typography><b>Tipo:</b> {selectedScad.tipo}</Typography>
            <Typography><b>Rata:</b> {selectedScad.numerorata}</Typography>
            <Typography><b>Data Scadenza:</b> {formatDate(selectedScad.dataScadenza)}</Typography>
            <Typography><b>Importo:</b> {selectedScad.importo} €</Typography>
            <Typography><b>Stato:</b> {selectedScad.stato}</Typography>
            <Typography><b>Codice Pagamento:</b> {selectedScad.codiceModuloPagamento || '-'}</Typography>
            {selectedScad.qrcode && selectedScad.qrcode!=="" && (
            <Typography mt={1}>
               <QRCode value={selectedScad.qrcode} />
              {selectedScad.qrcode}
            </Typography>
            )}

          </DialogContent>
        )}
        <DialogActions>
          {user.role==='CONTRIBUENTE' && selectedScad && selectedScad.stato !== "pagata" && (
            <Button variant="contained" color="success" startIcon={<PaymentIcon />} onClick={() => {
              markPaid(selectedScad.id);
              setModalOpen(false);
            }}>{selectedScad.direzione=="ENTRATA"?"Marca come incassata":"Marca come pagata"}</Button>
          )}
          <Button onClick={() => setModalOpen(false)}>Chiudi</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
